import React from "react";
import LegalLayout from "./LegalLayout";

const RecoveryPolicy = () => (
  <LegalLayout
    title="Recovery Policy"
    subtitle="Pawansut Holdings Limited — Fair and lawful recovery practices"
  >
    <p className="last-updated">Last updated: February 2025</p>
    <p className="intro">
      Pawansut Holdings Limited is committed to recovering dues in a lawful,
      fair, and respectful manner. This Recovery Policy sets out the principles
      and processes we follow for collection of overdue amounts, in compliance
      with RBI guidelines, our Fair Practice Code, and applicable laws.
    </p>

    <section>
      <h2>1. Objective</h2>
      <p>
        The objective of this policy is to ensure that recovery efforts are
        conducted with integrity, without harassment or intimidation, and in
        accordance with the terms of the loan agreement and regulatory
        directives. We aim to balance the legitimate interest of recovering
        dues with the dignity and rights of our customers.
      </p>
    </section>

    <section>
      <h2>2. Principles</h2>
      <ul>
        <li><strong>Lawful conduct:</strong> All recovery actions are in compliance with applicable laws, including the RBI directives on recovery agents and fair practices.</li>
        <li><strong>No harassment:</strong> We do not use abusive language, threats, or physical intimidation. We do not contact borrowers at odd hours beyond what is reasonably necessary and permitted.</li>
        <li><strong>Transparency:</strong> Borrowers are informed about outstanding dues, applicable charges, and the consequences of continued default in a clear manner.</li>
        <li><strong>Confidentiality:</strong> Information about the borrower and the loan is shared only with authorised personnel and agents, and only to the extent necessary for recovery.</li>
      </ul>
    </section>

    <section>
      <h2>3. In-House Recovery</h2>
      <p>
        Our staff responsible for follow-up and recovery are trained on this
        policy and the Fair Practice Code. They identify themselves clearly,
        maintain professional conduct, and use only approved scripts and
        communication channels. Escalation within the Company is done in a
        structured manner before referring to external agencies.
      </p>
    </section>

    <section>
      <h2>4. Third-Party Recovery Agents</h2>
      <p>
        Where we engage third-party recovery agents, we ensure they are
        registered and compliant with RBI guidelines. We have agreements that
        bind them to the same standards of conduct as set out in this policy.
        We do not assign recovery to agents who have been debarred by RBI or
        who do not adhere to our code of conduct. We monitor their performance
        and take action in case of violations.
      </p>
    </section>

    <section>
      <h2>5. Contact and Communication</h2>
      <p>
        We contact borrowers through phone, email, SMS, or post as per the
        contact details provided. We avoid unreasonable frequency of calls or
        visits. We do not contact family members, neighbours, or employers for
        recovery except as permitted by law and our internal guidelines.
      </p>
    </section>

    <section>
      <h2>6. Notice and Opportunity</h2>
      <p>
        Before initiating legal or other coercive measures, we typically send
        notices as per the loan agreement and legal requirements, giving the
        borrower an opportunity to regularise the account or communicate any
        genuine difficulty. We consider restructuring or settlement where
        feasible and in line with our policies.
      </p>
    </section>

    <section>
      <h2>7. Legal Remedies</h2>
      <p>
        Where recovery through normal follow-up is not successful, we may
        pursue legal remedies as per the loan agreement and applicable law,
        including invocation of security (if any), recovery through courts, or
        referral to recovery mechanisms as permitted. All such actions are
        taken in compliance with law and after due internal approval.
      </p>
    </section>

    <section>
      <h2>8. Credit Bureau Reporting</h2>
      <p>
        Default and delinquency may be reported to credit information companies
        as per the terms of the agreement and RBI guidelines. Borrowers are
        informed about the impact of default on their credit profile through
        standard communications.
      </p>
    </section>

    <section>
      <h2>9. Grievances</h2>
      <p>
        If a borrower believes that recovery has been conducted in violation of
        this policy or in an unfair manner, they may lodge a complaint with our
        Grievance Redressal Officer. We will investigate and take corrective
        action where warranted. Details are in our Grievance Redressal Policy.
      </p>
    </section>

    <section>
      <h2>10. Review</h2>
      <p>
        This Recovery Policy is reviewed periodically and updated to align with
        RBI guidelines and best practices. The policy is available on our
        website for reference.
      </p>
    </section>
  </LegalLayout>
);

export default RecoveryPolicy;
